<div class="flex flex-row justify-start items-center">
  <div class="pl-[{{ offset }}]">
    <button type="button" (click)="toggleExpand()" mat-icon-button>
      <mat-icon>{{ expandIcon }}</mat-icon>
    </button>
  </div>
  @if (icon) {
    <div>
      <mat-icon [rxapIcon]="icon"></mat-icon>
    </div>
  }
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
